import {
  FOOTER_COUNTERS_REFRESH_FAILED,
  FOOTER_COUNTERS_REFRESH_LOADING,
  FOOTER_COUNTERS_REFRESH_SUCCESS,
} from "../types"

const initialState = {
  loading: false,
  error: false,
  message: null,
  counters: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FOOTER_COUNTERS_REFRESH_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        message: null,
        counters: null,
      }
    case FOOTER_COUNTERS_REFRESH_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        counters: null,
      }
    case FOOTER_COUNTERS_REFRESH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: null,
        counters: action.payload,
      }
    default:
      return state
  }
}
